import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { InsightsSection } from '../components/InsightsSection';
import { UsersIcon } from 'lucide-react';
export function ChildCustodyInvestigations() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-332">
      <Header data-id="element-333" />

      {/* Banner Section */}
      <section className="relative w-full h-[400px] bg-gradient-to-br from-kgi-blue-900 to-kgi-blue-800 overflow-hidden mt-20" data-id="element-334">
        <div className="absolute inset-0 bg-black opacity-20" data-id="element-335"></div>
        <div className="relative container mx-auto px-4 h-full flex items-center justify-center" data-id="element-336">
          <div className="text-center" data-id="element-337">
            <UsersIcon className="h-20 w-20 text-white mx-auto mb-6 drop-shadow-lg" data-id="element-338" />
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 drop-shadow-lg" data-id="element-339">
              Child Custody Investigations
            </h1>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto drop-shadow" data-id="element-340">
              Protecting children's welfare through thorough investigation
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white" data-id="element-341">
        <div className="container mx-auto px-4" data-id="element-342">
          <div className="max-w-4xl mx-auto" data-id="element-343">
            <div className="prose prose-lg max-w-none mb-12" data-id="element-344">
              <p className="text-xl text-gray-700 leading-relaxed mb-6" data-id="element-345">
                Child custody cases are among the most sensitive and important
                investigations we handle. At Koda Group Inc., we understand that
                the welfare of children is paramount in custody disputes. Our
                investigators gather evidence to help courts make informed
                decisions about custody arrangements, ensuring that children are
                placed in safe, nurturing environments. We approach every case
                with compassion while maintaining the objectivity needed to
                document facts accurately.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-346">
                Our child custody investigations focus on documenting parenting
                capabilities, living conditions, and any factors that may affect
                a child's wellbeing. We conduct discreet surveillance, interview
                witnesses, and gather evidence of substance abuse, neglect, or
                unsafe living conditions when necessary. Our detailed reports
                provide courts and attorneys with the information needed to make
                custody decisions that serve the best interests of the child.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-347">
                Our child custody investigation services include parenting
                capability assessments, home environment evaluations, substance
                abuse documentation, lifestyle and fitness investigations,
                school and activity participation monitoring, witness interviews
                and statements, documentation of parental alienation, and
                compliance with custody order verification. We work closely with
                family law attorneys to support their clients' custody cases.
              </p>
            </div>

            <div className="text-center bg-gray-50 rounded-lg p-8" data-id="element-348">
              <h3 className="font-serif text-2xl font-bold text-kgi-blue-900 mb-4" data-id="element-349">
                Protect Your Child's Best Interests
              </h3>
              <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-350">
                Contact us for a confidential consultation about your child
                custody investigation needs.
              </p>
              <a href="/contact-koda-private-investigators.html" className="inline-flex items-center bg-kgi-red hover:bg-kgi-red-600 text-white font-bold py-4 px-10 rounded-full transition duration-300 shadow-xl text-lg" data-id="element-351">
                Schedule a Consultation
              </a>
            </div>
          </div>
        </div>
      </section>

      <InsightsSection data-id="element-352" />
      <Footer data-id="element-353" />
    </div>;
}